var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupUserPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3935 12.0021V10.81C15.3935 10.1777 15.1423 9.57127 14.6952 9.12416C14.2481 8.67705 13.6417 8.42586 13.0094 8.42586H8.24107C7.60876 8.42586 7.00235 8.67705 6.55523 9.12416C6.10812 9.57127 5.85693 10.1777 5.85693 10.81V12.0021M18.9697 12.0019V10.8098C18.9693 10.2816 18.7935 9.7684 18.4698 9.35091C18.1462 8.93341 17.6931 8.63522 17.1816 8.50316M14.7975 1.35074C15.3103 1.48204 15.7648 1.7803 16.0894 2.19848C16.4141 2.61667 16.5902 3.13099 16.5902 3.66037C16.5902 4.18975 16.4141 4.70408 16.0894 5.12226C15.7648 5.54045 15.3103 5.8387 14.7975 5.97001M13.0094 3.65758C13.0094 4.9743 11.9419 6.04172 10.6252 6.04172C9.30849 6.04172 8.24107 4.9743 8.24107 3.65758C8.24107 2.34085 9.30849 1.27344 10.6252 1.27344C11.9419 1.27344 13.0094 2.34085 13.0094 3.65758Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.08992 0C3.28773 -1.00638e-08 3.44809 0.160358 3.44809 0.358169L3.44809 5.76113C3.44809 5.95894 3.28773 6.11929 3.08992 6.11929C2.89211 6.11929 2.73175 5.95894 2.73175 5.76113V0.358169C2.73175 0.160358 2.89211 -1.00638e-08 3.08992 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14957 3.05965C6.14957 3.25746 5.98921 3.41782 5.7914 3.41782H0.388442C0.190631 3.41782 0.0302734 3.25746 0.0302734 3.05965C0.0302732 2.86184 0.190631 2.70148 0.388442 2.70148H5.7914C5.98921 2.70148 6.14957 2.86184 6.14957 3.05965Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupUserPlus);
export default __webpack_public_path__ + "static/media/group-user-plus.e9d378cad1c99108578f6097cf0a7edb.svg";
export { ForwardRef as ReactComponent };